import { WavesIcon } from './WavesIcon';

/**
 * author: Michael Irigoyen
 * id 547979BF-6FF4-4CFF-BD55-1E5793C9DAA3
 * name waves
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/waves.svg
 * tags
 * - Weather 
 * - Transportation + Water 
 * - Agriculture 
 */
export const FloodIcon = WavesIcon;
export default FloodIcon